/**
 * Add values to an object or push to an array
 * @param {Object|Array} data - The data to add values to
 * @param {*} valuesToAdd - The values to add
 * @returns {Object|Array} The updated data
 */
export function addValue(data, valuesToAdd) {
  if (data === undefined) {
    data = $.isArray(valuesToAdd) ? [] : {}
  }
  if ($.isArray(data)) {
    data.push(valuesToAdd)
  } else {
    for (const name in valuesToAdd) {
      data[name] = valuesToAdd[name]
    }
  }
  return data
}

/**
 * Set a value at a specific property or index in an object/array
 * @param {Object|Array} data - The data object or array
 * @param {string|number} propertyOrIndex - The property name or index
 * @param {*} valuesToSet - The value to set
 */
export function setValue(data, propertyOrIndex, valuesToSet) {
  data[propertyOrIndex] = valuesToSet
}
